// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1uY3y","title":"Images45_title__3Qeb-","images":"Images45_images__4GrIR"};